import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import { Pagination } from 'swiper/modules';

import { classes } from '../const';

const { isMasked } = classes;

const initHomeSlider = $el => {
  const $slider = $el.find('.swiper-container');

  const slider = new Swiper($slider[0], {
    modules: [Navigation],
    init: false,
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    autoplay: {
      disableOnInteraction: false
    },
    effect: 'fade',
    /* pagination: {
      el: $el.find('.swiper-pagination')[0],
      type: 'bullets',
      clickable: true
    } */
  });

  slider.init();
};

const initLargeSlider = $el => {
  const $slider = $el.find('.swiper-container');

  const slider = new Swiper($slider[0], {
    modules: [Navigation],
    init: false,
    slidesPerView: 1,
    speed: 1000,
    /* pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }, */
    navigation: {
      nextEl: '.js-next-arr',
      prevEl: '.js-prev-arr' 
    },
    on: {
      init() {
        $(this.slides).each((i, slide) => {
          $(slide).click(event => {
            if (i !== this.activeIndex) {
              event.preventDefault();
              this.slideTo(i);
            }
          });
        });
      }
    }
  });

  slider.init();
};

const initTestimonialSlider = $el => {
  const $slider = $el.find('.swiper-container');

  const slider = new Swiper($slider[0], {
    modules: [Navigation],
    init: false,
    slidesPerView: 1,
    speed: 1000,
    /* pagination: {
      el: $el.find('.swiper-pagination')[0],
      type: 'bullets',
      clickable: true
    }, */
    on: {
      init() {
        $(this.slides).each((i, slide) => {
          $(slide).click(event => {
            event.preventDefault();
            if (i !== this.activeIndex) {
              this.slideTo(i);
            }
          });
        });
      }
    }
  });

  slider.init();
};

const initNewsSlider = $el => {
  const $slider = $el.find('.swiper-container');

  const slider = new Swiper($slider[0], {
    modules: [Navigation],
    init: false,
    slidesPerView: 1,
    speed: 1000,
    navigation: {
      nextEl: '.js-next-arr',
      prevEl: '.js-prev-arr' 
    },
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 3
      }
    },
  });

  slider.init();

};

const initTeaserSlider = $el => {
  const $slider = $el.find('.swiper-container');

  const maskSlides = (swiper, slideChange) => {

    const aciveSlidesNum = swiper.params.slidesPerView;
    const swipeDir = swiper.previousTranslate < swiper.translate ? 'left' : 'right';
    const { activeIndex } = swiper;

    const $$slides = $(swiper.slides);
    const sliderLeft = $slider.offset().left;
    const sliderWidth = $slider.outerWidth();

    if (slideChange) {
      const $activeSlide = $($$slides[activeIndex]);
      $activeSlide.removeClass(isMasked);
      $activeSlide.prevAll().addClass(isMasked);
      $activeSlide.nextAll().each((i, slide) => {
       if (i < aciveSlidesNum - 1) {
        $(slide).removeClass(isMasked);
       } else {
         $(slide).addClass(isMasked);
       }
      });
      return;
    }

    let firstLeftSlideFound = false;

    $$slides.each((i, slide) => {

      if (firstLeftSlideFound) return;

      const slideLeft = $(slide).offset().left;
      const slideWidth = $(slide).outerWidth();

      const conditionLeft = slideLeft < sliderLeft;
      const conditionRight = slideLeft + slideWidth - 1 > sliderLeft + sliderWidth

      if (!conditionLeft && !conditionRight) {
        firstLeftSlideFound = true;
        $(slide).removeClass(isMasked);
        if (swipeDir === 'right') {
          $(slide).prevAll().addClass(isMasked);
          $(slide).nextAll().each((j, nextSlide) => {
            if (j < aciveSlidesNum - 1) {
             $(nextSlide).removeClass(isMasked);
            } else {
              $(nextSlide).addClass(isMasked);
            }
           });
        } else {
          $($(slide).prevAll().get().reverse()).each((j, prevSlide) => {
            if (j < aciveSlidesNum - 1) {
             $(prevSlide).removeClass(isMasked);
            } else {
              $(prevSlide).addClass(isMasked);
            }
           });
           $(slide).nextAll().addClass(isMasked);
        }
      } else {
        $(slide).addClass(isMasked);
      }
    });
  }

  const slider = new Swiper($slider[0], {
    modules: [Navigation],
    init: false,
    slidesPerView: 1,
    speed: 1000,
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    },
    on: {
      init() {
        $(this.slides).each((i, slide) => {
          $(slide).click(event => {
            if(i > this.activeIndex + 2 || i < this.activeIndex ) {
              event.preventDefault();
              this.slideTo(i);
            }
          });
        });
        maskSlides(this);
      },
      resize() {
        maskSlides(this);
      },
      sliderMove() {
        maskSlides(this);
      },
      slideChange() {
        maskSlides(this, true);
      },
      transitionEnd() {
        maskSlides(this, true);
      },
      touchEnd() {
        maskSlides(this, true);
      }
    }
  });

  slider.init();

};

const sliders = () => {
  const $$teaserSliders = $('.js-teaser-slider');
  const $$newsSliders = $('.js-news-slider');
  const $$testimonialSliders = $('.js-testimonial-slider');
  const $$largeSliders = $('.js-large-slider');
  const $$homeSliders = $('.js-home-slider');

  $$teaserSliders.each((i, el) => {
    initTeaserSlider($(el));
  });

  $$newsSliders.each((i, el) => {
    initNewsSlider($(el));
  });

  $$testimonialSliders.each((i, el) => {
    initTestimonialSlider($(el));
  });

  $$largeSliders.each((i, el) => {
    initLargeSlider($(el));
  });

  $$homeSliders.each((i, el) => {
    initHomeSlider($(el));
  });
};

export default sliders;
